import { RouteConfig } from 'vue-router'

const authRoutes: RouteConfig[] = [
  {
    name: 'auth.login',
    path: '/auth/login',
    component: () => import('@/modules/auth/views/Login.vue')
  },
  {
    name: 'auth.userRecovery',
    path: '/auth/users/recovery',
    component: () => import('@/modules/auth/views/UserRecovery.vue')
  },
  {
    name: 'auth.userRecoveryToken',
    path: '/auth/users/recovery/:token',
    component: () => import('@/modules/auth/views/UserRecoveryToken.vue')
  }
]

export default authRoutes